import {useGlobals} from '../../globalPropsContext';

export const useSidePanel = () => {
  const {useSidePanel: _useSidePanel} = useGlobals();
  return _useSidePanel;
};
